// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Zmpm","options":"AnswerScale_options__3vFfr","selected":"AnswerScale_selected__3AxNK"};